import { keyframes } from 'styled-components';

export const bounce = keyframes`
  0%, 44%, 50%, 56%, 60%, to {
    transform: translateY(0);
  }

  47% {
    transform: translateY(-20px);
  }

  53% {
    transform: translateY(-10px);
  }

  58% {
    transform: translateY(-3px);
  }
`;
